import { AdaLocalizedPercentPipe, PlaceholderIfEmptyPipe } from '@adaptiva/core/common';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ChartComponent } from '@adaptiva/widgets/charts';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule, PipeTransform, Type } from '@angular/core';
import { CveCountsDisplayComponent } from './cve-counts-display.component';
import { TemplatizeCveCountsPipe } from './pipes';

const PIPES: Type<PipeTransform>[] = [
	AdaLocalizedPercentPipe,
	PlaceholderIfEmptyPipe,
	TemplatizeCveCountsPipe
];

const WIDGETS: Type<NgModule>[] = [
	CardComponentModule,
	ChartComponent,
	ContainerComponentModule,
	TextComponentModule,
];

@NgModule({
	imports: [
		PIPES,
		WIDGETS,
		CommonModule
	],
	declarations: [CveCountsDisplayComponent],
	exports: [CveCountsDisplayComponent]
})
export class CveCountsDisplayComponentModule {

}
